var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnergyCommunity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 -0.02 366.5 409.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M183.24,19.2a26.41,26.41,0,1,0,26.41,26.4,26.43,26.43,0,0,0-26.41-26.4m0,72A45.61,45.61,0,1,1,228.85,45.6a45.67,45.67,0,0,1-45.61,45.62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M183.24,139.46a9.6,9.6,0,0,1-9.6-9.6V81.62a9.6,9.6,0,1,1,19.2,0v48.24a9.6,9.6,0,0,1-9.6,9.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M131.07,184a9.61,9.61,0,0,1-4.8-1.29L72,151.39a9.6,9.6,0,0,1,9.6-16.63l54.28,31.34a9.6,9.6,0,0,1-4.8,17.92"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.8,275.59A9.6,9.6,0,0,1,72,257.67l70.35-40.6a9.6,9.6,0,0,1,9.6,16.62L81.59,274.31a9.56,9.56,0,0,1-4.79,1.28"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M183.24,337.05a9.59,9.59,0,0,1-9.6-9.6V279.21a9.6,9.6,0,1,1,19.2,0v48.24a9.6,9.6,0,0,1-9.6,9.6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M289.68,275.59a9.56,9.56,0,0,1-4.79-1.28l-70.34-40.62a9.6,9.6,0,1,1,9.6-16.62l70.34,40.6a9.6,9.6,0,0,1-4.81,17.92"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M235.42,184a9.6,9.6,0,0,1-4.81-17.92l54.29-31.34a9.6,9.6,0,0,1,9.59,16.63l-54.28,31.34a9.58,9.58,0,0,1-4.79,1.29"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.65,98.67a26.4,26.4,0,1,0,13.16,3.53,26.16,26.16,0,0,0-13.16-3.53m-.12,72A45.61,45.61,0,1,1,68.41,85.56h0a45.6,45.6,0,0,1-22.88,85.1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.39,261.13a26.41,26.41,0,1,0,36.09,9.66,26.44,26.44,0,0,0-36.09-9.66M45.68,329.6a45.61,45.61,0,1,1,22.73-6.11,45.61,45.61,0,0,1-22.73,6.11"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M183.24,337.06a26.41,26.41,0,1,0,26.41,26.4,26.43,26.43,0,0,0-26.41-26.4m0,72a45.61,45.61,0,1,1,45.61-45.61,45.66,45.66,0,0,1-45.61,45.61"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M320.92,257.57a26.56,26.56,0,0,0-6.88.92,26.13,26.13,0,1,0,6.88-.92m-.12,72a45.61,45.61,0,1,1,39.58-22.8,45.3,45.3,0,0,1-39.58,22.8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M320.83,98.66a26.41,26.41,0,1,0,13.25,49.28h0a26.4,26.4,0,0,0-13.25-49.28m.12,72a45.87,45.87,0,0,1-11.87-1.57A45.35,45.35,0,1,1,321,170.7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M155.07,244.86h0Zm56.34,0h0Zm-9.6,9.6a9.59,9.59,0,0,1-9.6-9.6c0-7.64,5.59-14.13,13.33-23.1,9.36-10.87,21-24.38,21-39a43.31,43.31,0,1,0-86.61,0c0,14.61,11.64,28.12,21,39,7.74,9,13.34,15.46,13.34,23.1a9.6,9.6,0,0,1-19.18.65c-.88-2.14-5.39-7.38-8.71-11.22-10.82-12.56-25.66-29.77-25.66-51.52a62.51,62.51,0,1,1,125,0c0,21.75-14.83,39-25.66,51.52-3.32,3.84-7.83,9.08-8.71,11.22a9.58,9.58,0,0,1-9.57,9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M174.28,254.46V268.2a1.4,1.4,0,0,0,1.39,1.41h15.14a1.41,1.41,0,0,0,1.4-1.41V254.46Zm16.53,34.35H175.67a20.62,20.62,0,0,1-20.6-20.61V244.86a9.61,9.61,0,0,1,9.6-9.6h37.14a9.61,9.61,0,0,1,9.6,9.6V268.2a20.62,20.62,0,0,1-20.6,20.61"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergyCommunity);
export default __webpack_public_path__ + "static/media/energy-community.69c8fb06923c5b80d48f2567c7715909.svg";
export { ForwardRef as ReactComponent };